import { MAX_AMOUNT_CARD_DEFAULT } from '@constants';

export function getConfigByCountry(country) {
    if (!window.configByCountry || !window.configByCountry[country])
        return;

    return window.configByCountry[country];
}

export function getMaxAmountCardInvoiceByCountry(country) {
    let config = getConfigByCountry(country);
    return (config) ?
         config.amount_max_by_invoice || MAX_AMOUNT_CARD_DEFAULT : MAX_AMOUNT_CARD_DEFAULT; 
}